import { WindowTypeEnum } from "./enums/WindowTypeEnum";
import { ClassicyIcon } from "./components/icon/ClassicyIcon";

interface DesktopIconsProps {
  onOpen: (windowType: WindowTypeEnum) => void;
}

function DesktopIcons({ onOpen }: DesktopIconsProps) {
  // Desktop is 1600x900px
  // Position icons in bottom-right corner, stacked vertically
  const iconSize = 64; // Desktop icons are 64px
  const iconWidth = 80;
  const iconHeight = 80;
  const padding = 64;
  const desktopWidth = 1580;
  const desktopHeight = 860;

  const getBottomRightPosition = (index: number): [number, number] => {
    return [
      desktopWidth - iconWidth - padding,
      desktopHeight - (iconHeight + padding) * (index + 1),
    ];
  };

  return (
    <>
      <ClassicyIcon
        appId="visitor-stories"
        name="Visitor Stories"
        icon="/assets/icons/text.png"
        label="Besuchergeschichten"
        size={iconSize}
        fontSize={16}
        position={getBottomRightPosition(2)}
        onClickFunc={() => onOpen(WindowTypeEnum.VisitorStories)}
      />
      <ClassicyIcon
        appId="submit-story"
        name="Submit Story"
        icon="/assets/icons/mac.png"
        label="Eigene Geschichte teilen"
        size={iconSize}
        fontSize={16}
        position={getBottomRightPosition(1)}
        onClickFunc={() => onOpen(WindowTypeEnum.SubmitStory)}
      />
      <ClassicyIcon
        appId="device-story"
        name="Device Story"
        icon="/assets/icons/quicktime/control-panel.png"
        label="iMac G3 Device Story"
        size={iconSize}
        fontSize={16}
        position={getBottomRightPosition(0)}
        onClickFunc={() => onOpen(WindowTypeEnum.DeviceStory)}
      />
    </>
  );
}

export default DesktopIcons;
